<template>
  <div
    :class="`bignumber dg ${componentMobileClass}`"
    ref="chartcontainer"
    style="position: relative"
  >
    <slot></slot>
  </div>
</template>
<script>
import ComponentSizeMixin from "./ComponentSizeMixin";

export default {
  name: "BigNumberParent",
  mixins: [ComponentSizeMixin]
};
</script>

<style scoped>
.bignumber {
  position: relative;
  padding: 6px;
}

@media (min-width: 700px) {
  .cmc_normal.bignumber {
    padding: 0.7em 0.7em;
  }
}
@media (min-width: 900px) {
  .cmc_normal.bignumber {
    padding: 1.1em 1.1em;
    margin: 1em;
  }
}
</style>
